import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {PopulateTranslationsDialogState} from "../types/PopulateTranslationsDialogState";

export const usePopulateTranslationsDialog = () => useDialogContext<PopulateTranslationsDialogState>('populate-translations');
